export const NO_RESPONSE_STATUS_CODE = -1;
